import { MethodSummary } from "../models/methodSummary";
import { Params } from "../models/params";

export class MethodServiceJava{

    public getSGConnectEdgeMethods():MethodSummary[]{
      var methods:MethodSummary[] = [
        new MethodSummary("static void",
        "addObserver",
        "Registers an observer that returns the state of the bluetooth module",
        new Params(["SGBLEObserver", "String"],                       //parameter type
        ["Observer that triggers on bluetooth connectivity status changes", "Optional key that is used to register/unregister the observer"],    //parameter description
        ["onStateChange","key"]),                                   //parameter name
        ""
        ),
        new MethodSummary("static void",
        "addObserver",
        "Registers an observer that returns the state of the transaction",
        new Params(["SGTransferObserver", "String"],
        ["Observer that triggers on transaction state change", "Optional key that is used to register/unregister the observer"],
        ["onStateChange", "key"]),
        ""
        ),
        new MethodSummary("static void",
        "removeObserver",
        "Removes a previously registered observer",
        new Params([ "String"],
        ["Key of the previously registered observer"],
        ["key"]),
        ""
        ),
        new MethodSummary("static void",
        "removeAllObservers",
        "Removes all previously registered observers",
        new Params([],
        [],
        []),
        ""
        ),
        new MethodSummary("static void",
        "purchaseChips",
        "Automatically scans, connects, and then initiates a purchase chips transaction. Can check the callback or the registered SGTransferObserver for status.",
        new Params(["android.app.Activity","String", "int", "String", "SGFundTransferCallback"],
        ["Context", "User card number", "Amount to be transfered, in cents", "Patron's name", "Transfer status callback"],
        ["activity", "cardNumber", "amountInCents", "playerName", "callback"]),
        ""
        ),
        new MethodSummary("static void",
        "sellChips",
        "Automatically scans, connects, and then initiates a chip sale transaction. Can check the callback or the registered SGTransferObserver for status.",
        new Params(["android.app.Activity","String", "int", "String", "SGFundTransferCallback"],
        ["Context", "User card number", "Amount to be transfered, in cents", "Patron's name", "Transfer status callback"],
        ["activity", "cardNumber", "amountInCents", "playerName", "callback"]),
        ""
        ),
        new MethodSummary("static void",
        "acceptTransfer",
        "Automatically scans, connects, and approves a fund transfer initiated by a supervisor. Can check the callback or the registered SGTransferObserver for status.",
        new Params(["android.app.Activity","String", "String", "SGFundTransferCallback"],
        ["Context", "User card number", "Patron's name", "Transfer status callback"],
        ["activity", "cardNumber", "playerName", "callback"]),
        ""
        ),
        new MethodSummary("static boolean",
        "isSupported",
        "Checks for BLE Support on this device",
        new Params([],
        [],
        []),
        "Returns whether or not the phone supports BLE >= Lollipop"
        ),
        new MethodSummary("static void",
        "onActivityResult",
        "Needs to call activity's onActivityResult in order to automatically start connecting to gaming machine once all required hardware has been turned on",
        new Params(["int","int", "android.content.Intent"],
        ["Request code", "result code", "intent data"],
        ["request","result","data"]),
        ""
        ),
        new MethodSummary("static void",
        "onRequestPermissionsResult",
        "Needs to call activity's onRequestPermissionsResult in order to automatically start connecting to gaming machine all permission requests have been accepted.",
        new Params(["int","int", "android.content.Intent"],
        ["Request code", "result code", "intent data"],
        ["request","result","data"]),
        ""
        ),
        new MethodSummary("static void",
        "setConnectionRange",
        "Sets the signal strength range to establish a connection to the Gaming Machine, and to disconnect from it.",
        new Params(["Integer","Integer"],
        ["The value at or below which the mobile can connect to the Gaming Machine. Value must be between 20 and 70.",
        "The value at or beyond which the mobile will warn the player about being far from the Gaming Machine and would disconnect if the player does not return within 10 secs. Value must be greater than connectRSSI and not greater than 100."],
        ["connectRSSI","disconnectRSSI"]),
        ""
        )

      ]
    return methods;
    }

    public getSGBLEConnectMethods():MethodSummary[]{
        var methods:MethodSummary[] = [
            new MethodSummary("static void",
            "addObserver",
            "Registers an observer that returns the state of the bluetooth module",
            new Params(["SGBLEObserver", "String"],                       //parameter type
            ["Observer that triggers on bluetooth connectivity status changes", "Optional key that is used to register/unregister the observer"],    //parameter description
            ["onStateChange","key"]),                                   //parameter name
            ""
            ),
            new MethodSummary("static void",
            "addObserver",
            "Registers an observer that returns the state of the user session",
            new Params(["SGSessionObserver", "String"],
            ["Observer that triggers on bluetooth state change", "Optional key that is used to register/unregister the observer"],
            ["onStateChange", "key"]),
            ""
            ),
            new MethodSummary("static void",
            "addObserver",
            "Registers an observer that fires when the state of the user proximity changes",
            new Params(["SGProxObserver", "String"],
            ["Observer that triggers on proximity state change", "Optional key that is used to register/unregister the observer"],
            ["onStateChange", "key"]),
            ""
            ),
            new MethodSummary("static void",
            "addObserver",
            "Registers an observer that fires when profile settings become available",
            new Params(["SGPlayerProfile", "String"],
            ["Observer that triggers on profile settings availability", "Optional key that is used to register/unregister the observer"],
            ["onStateChange", "key"]),
            ""
            ),
            new MethodSummary("static void",
            "removeObserver",
            "Removes a previously registered observer",
            new Params([ "String"],
            ["Key of the previously registered observer"],
            ["key"]),
            ""
            ),
            new MethodSummary("static void",
            "removeAllObservers",
            "Removes all previously registered observers",
            new Params([],
            [],
            []),
            ""
            ),
            new MethodSummary("static void",
            "createSession",
            "Automatically scans, connects, and then starts a session with the gaming machine. Check player-session and ble-status observable for status.",
            new Params(["android.app.Activity","String"],
            ["Context", "User card number"],
            ["activity", "cardNumber"]),
            ""
            ),
            new MethodSummary("static void",
            "endSession",
            "Sends a command to the gaming machine to end the user's session. Check player-session and ble-status observable for status.",
            new Params([],
            [],
            []),
            ""
            ),
            new MethodSummary("static Boolean",
            "isPrimaryIdentificationRequired",
            "Checks to see if a primary form of identification is required from the Player for transferring funds.",
            new Params([],
            [],
            []),
            "Returns null if it is called before `SGPlayerProfileState` goes to `PINSETTINGAVAILABLE`"
            ),
            new MethodSummary("static Boolean",
            "isFundsTransferSupported",
            "Checks if Funds Transfer is supported by the Electronic Gaming Machine",
            new Params([],
            [],
            []),
            "Returns null if it is called before `SGPlayerProfileState` goes to `FUNDTRANSFERSETTINGAVAILABLE`"
            ),
            new MethodSummary("static SGBalance",
            "getLastCashout",
            "Gets the last cashout for this player from a previous Gaming Machine.",
            new Params([],
            [],
            []),
            "Returns SGBalance if available, or null if it is called before a valid session is created."
            ),
            new MethodSummary("static void",
            "getBalances",
            "Retrieves the balances for all accounts that are active for the player",
            new Params(["SGPlayerBalanceCallback"],
            ["Callback that fires when balance is available."],
            ["onBalanceAvailable"]),
            ""
            ),
            new MethodSummary("static void",
            "transferAmount",
            "Transfer a given amount in a particular disposition from a source account to a destination account",
            new Params(["int","byte","byte","byte","String", "String", "SGFundTransferCallback"],
            ["ammount in cents","source of type 'SGAccountType'","destination of type 'SGAccountType'","funds of type 'SGDisposition'","Optional primary identifier e.g CMS Pin", "An optional secondary identifier","Callback that fires when fund transfer has finished."],
            ["cents","source","destination","disposition","primaryIdentifier","secondaryIdentifier","onTransferComplete"]),
            ""
            ),
            new MethodSummary("static boolean",
            "isSupported",
            "Checks for BLE Support on this device",
            new Params([],
            [],
            []),
            "Returns whether or not the phone supports BLE >= Lollipop"
            ),
            new MethodSummary("static void",
            "onActivityResult",
            "Needs to call activity's onActivityResult in order to automatically start connecting to gaming machine once all required hardware has been turned on",
            new Params(["int","int", "android.content.Intent"],
            ["Request code", "result code", "intent data"],
            ["request","result","data"]),
            ""
            ),
            new MethodSummary("static void",
            "onRequestPermissionsResult",
            "Needs to call activity's onRequestPermissionsResult in order to automatically start connecting to gaming machine all permission requests have been accepted.",
            new Params(["int","int", "android.content.Intent"],
            ["Request code", "result code", "intent data"],
            ["request","result","data"]),
            ""
            ),
            new MethodSummary("static void",
            "registerLogger",
            "Callback contains any logs that the framework may be outputting",
            new Params(["SGLoggerDelegate"],
            ["Triggers when framework outputs any logs"],
            ["logger"]),
            ""
            ),
            new MethodSummary("static void",
            "setLogLevel",
            "Filter out below a specified log level.",
            new Params(["SGLogLevel"],
            ["Specify the log level.  i.e ERROR to only get error logs. WARN to only get error and warning logs"],
            ["level"]),
            ""
            ),
            new MethodSummary("static void",
            "enable",
            "Enables an SG feature",
            new Params(["SGFeature"],
            ["Can pass in multiple features at once by using OR operator e.g SGFeature.SECURITY ^ SGFeature.OTHER"],
            ["feature"]),
            ""
            ),
            new MethodSummary("static void",
            "disable",
            "Disables an SG feature.",
            new Params(["SGFeature"],
            ["Can pass in multiple features at once by using OR operator e.g SGFeature.SECURITY ^ SGFeature.OTHER"],
            ["feature"]),
            ""
            ),
            new MethodSummary("static void",
            "setConnectionRange",
            "Sets the signal strength range to establish a connection to the Gaming Machine, and to disconnect from it.",
            new Params(["Integer","Integer"],
            ["The value at or below which the mobile can connect to the Gaming Machine. Value must be between 20 and 70.",
            "The value at or beyond which the mobile will warn the player about being far from the Gaming Machine and would disconnect if the player does not return within 10 secs. Value must be greater than connectRSSI and not greater than 100."],
            ["connectRSSI","disconnectRSSI"]),
            ""
            )
          ]
        return methods;
    }

    public getSGLogCallBackMethods():MethodSummary[]{
        var methods:MethodSummary[] = [
            new MethodSummary("void",
            "log",
            "Fires when app logs a message",
            new Params(
              ["SGLogLevel","String", "String"],
              ["The importance level of the log","The log message", "Tag attached to message"],
              ["level","message", "tag"]),
            ""
            )
          ]

          return methods;
    }


    public getSGBLEStatusCallBackMethods():MethodSummary[]{
        var methods:MethodSummary[] = [
            new MethodSummary("void",
            "onUpdate",
            "Fires when bluetooth changes state",
            new Params(
              ["java.lang.Enum"],
              ["The current bluetooth state"],
              ["state"]),
            ""
            ),
            new MethodSummary("void",
            "onError",
            "Fires if there is a bluetooth related error.",
            new Params(["SGError"],
            ["Object that holds the error type, a localized description, and stack trace if available."],
            ["error"]),
            ""
            )
          ]

          return methods;
    }

    public getSGSessionStatusCallBackMethods():MethodSummary[]{
        var methods:MethodSummary[] = [
            new MethodSummary("void",
            "onUpdate",
            "Fires when user session changes state",
            new Params(
              ["java.lang.Enum"],
              ["The current user session state"],
              ["state"]),
            ""
            ),
            new MethodSummary("void",
            "onError",
            "Fires if there is a user session related error.",
            new Params(["SGError"],
            ["Object that holds the error type, a localized description, and stack trace if available."],
            ["error"]),
            ""
            )
          ]

          return methods;
    }

    public getSGProxStatusCallBackMethods():MethodSummary[]{
      var methods:MethodSummary[] = [
          new MethodSummary("void",
          "onUpdate",
          "Fires when user goes out or in of bluetooth range",
          new Params(
            ["java.lang.Enum"],
            ["The current user proximity state (in range / out of range)"],
            ["state"]),
          ""
          ),
          new MethodSummary("void",
          "onError",
          "Fires if there is a proximity state related error.",
          new Params(["SGError"],
          ["Object that holds the error type, a localized description, and stack trace if available."],
          ["error"]),
          ""
          )
        ]

        return methods;
  }

  public getSGPlayerProfileCallBackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("void",
        "onUpdate",
        "Fires when player profile settings come throught the gaming machine",
        new Params(
          ["java.lang.Enum"],
          ["The profile settings that became available"],
          ["state"]),
        ""
        ),
        new MethodSummary("void",
        "onError",
        "Fires if there is a player profile state related error.",
        new Params(["SGError"],
        ["Object that holds the error type, a localized description, and stack trace if available."],
        ["error"]),
        ""
        )
      ]

      return methods;
}

  public getSGPlayerBalanceCallBackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("void",
        "onBalanceAvailable",
        "Fires when the gaming machine replies with available balances",
        new Params(
          ["SGBalance[]"],
          ["The current player balance state"],
        ["balances"]),
        ""
        ),
        new MethodSummary("void",
        "onError",
        "Fires if there is a funds related error.",
        new Params(["SGError"],
        ["Object that holds the error type, a localized description, and stack trace if available."],
        ["error"]),
        ""
        )
      ]

      return methods;
}

  public getSGFundTransferCallbackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("void",
        "onTransferComplete",
        "Fires when the gaming machine completes fund transfer",
        new Params(
          ["SGTransfer"],
          ["Fires when the transfer succesfully completes"],
          []),
        ""
        ),
        new MethodSummary("void",
        "onError",
        "Fires if funds transfer does not complete",
        new Params(["SGError"],
        ["Object that holds the error type, a localized description, and stack trace if available."],
        ["error"]),
        ""
        )
      ]

      return methods;
  }

  public getSGFundTransferEdgeCallbackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("void",
        "onTransferComplete",
        "Triggered when the payment device completes fund transfer",
        new Params(
          [""],
          [""],
          []),
        ""
        ),
        new MethodSummary("void",
        "onError",
        "Triggered if funds transfer does not complete",
        new Params(["SGError"],
        ["Object that holds the error type, a localized description, and stack trace if available."],
        ["error"]),
        ""
        )
      ]

      return methods;
  }


  public getSGQRConnectEdgeMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("static void",
        "initialize",
        "Initializes with settings required for network validation",
        new Params(["SGConfiguration", "InputStream"],
        ["SGConfiguration initialized with 2 values: Cardless coordinator url and authToken(optional parameter)",
        "Input Stream of the image that needs to be displayed in scanner/camera screen. This logo has to be in the dimension 803 × 373."],
        ["sgConfig", "is"]),
        ""
        ),
        new MethodSummary("static void",
        "addObserver",
        "Registers an observer that returns the state of the QR module. Can register multiple observers",
        new Params(["SGQRObserver", "String"],
        ["Callback that triggers on QR status change", "Key used to register/unregister from observable"],
        ["obs","key"]),
        ""
        ),
        new MethodSummary("static void",
        "createSession",
        "Automatically scans, connects, and then starts a session with the gaming machine.",
        new Params(["Activity","SGQRSessionCreationOptions", "String"],
        ["Context", "Session creation options type selected (account number, or phone number etc)", "Value of the option selected"],
        ["activity", "sessionOptions","value"]),
        ""
        ),
        new MethodSummary("static boolean",
        "isSupported",
        "Is QR supported?",
        new Params([],
        [],
        []),
        "Returns whether or not the phone supports QR scanning capabilities"
        )
      ]
      return methods;
  }

  public getSGQRConnectMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("static void",
        "initialize",
        "Initializes with settings required for network validation",
        new Params(["SGConfiguration"],
        ["The URL of the mobile app server."],
        []),
        ""
        ),
        new MethodSummary("static void",
        "addObserver",
        "Registers an observer that returns the state of the QR module. Can register multiple observers",
        new Params(["SGConnectQR.SGQRStatusCallBack"],
        ["Callback that triggers on QR status change"],
        []),
        ""
        ),
        new MethodSummary("static void",
        "addObserver",
        "Registers an observer that returns the state of the user session",
        new Params(["SGSessionStatusCallBack"],
        ["Callback that triggers on session state change"],
        []),
        ""
        ),
        new MethodSummary("static void",
        "createSession",
        "Automatically scans, connects, and then starts a session with the gaming machine.",
        new Params(["android.app.Activity","String"],
        ["Context", "User card number"],
        []),
        ""
        ),
        new MethodSummary("static void",
        "endSession",
        "Sends a command to the gaming machine to end the user's session.",
        new Params([],
        [],
        []),
        ""
        ),
        new MethodSummary("static boolean",
        "isSupported",
        "Is QR supported?",
        new Params([],
        [],
        []),
        "Returns whether or not the phone supports QR scanning capabilities"
        ),
        new MethodSummary("static void",
        "destroyConnection",
        "Needs to call activity's onDestroy in order to do some cleanup",
        new Params(["int","int", "android.content.Intent"],
        ["Request code", "result code", "intent data"],
        []),
        ""
        )
      ]
      return methods;
  }

  public getSGQRStatusCallBackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("void",
        "onUpdate",
        "Fires when QR changes state",
        new Params(
          ["SGQRConnectionState"],
          ["The current QR state"],
          []),
        ""
        ),
        new MethodSummary("void",
        "onError",
        "Fires if there is a QR related error.",
        new Params(["SGError"],
        ["Object that holds the error type, a localized description, and stack trace if available."],
        []),
        ""
        )
      ]

      return methods;
}



}
